interface HotspotI<T, K> {
  name: T;
  params: K;
}

export enum Hotspots {
  OfferPromoteJobBoards = 'offer.promote.job_boards',
  OfferPipelineBadges = 'offer.pipeline.badges',
  SettingsIntegrationsPage = 'settings.integrations_page',
  SettingsIntegrationsItemBadges = 'settings.integrations_item_badges',
  CandidateProfileOverview = 'candidate_profile.overview',
  CandidateProfileMore = 'candidate_profile.more',
  CandidateProfileBadges = 'candidate_profile.badges',
  CandidatesTableBadges = 'candidates_table.badges',
  CompanyTeamMembersAdd = 'company.team_members.add',
  Debug = 'debug',
}

export type OfferPromoteJobBoardsHotspot = HotspotI<
  Hotspots.OfferPromoteJobBoards,
  { offerId: number; location?: string }
>;
export type OfferPipelineBadgesHotspot = HotspotI<
  Hotspots.OfferPipelineBadges,
  { candidateId: number }
>;
export type SettingsIntegrationsPageHotspot = HotspotI<Hotspots.SettingsIntegrationsPage, {}>;
export type SettingsIntegrationsItemBadges = HotspotI<Hotspots.SettingsIntegrationsItemBadges, {}>;
export type CandidateProfileOverviewHotspot = HotspotI<
  Hotspots.CandidateProfileOverview,
  { candidateId: number; offerId?: number }
>;
export type CandidateProfileMoreHotspot = HotspotI<
  Hotspots.CandidateProfileMore,
  { candidateId: number; offerId?: number }
>;
export type CandidateProfileBadgesHotspot = HotspotI<
  Hotspots.CandidateProfileBadges,
  { candidateId: number }
>;
export type CandidatesTableBadgesHotspot = HotspotI<
  Hotspots.CandidatesTableBadges,
  { candidateId: number }
>;

export type CompanyTeamMembersAddHotspot = HotspotI<Hotspots.CompanyTeamMembersAdd, {}>;

export type DebugHotspot = HotspotI<Hotspots.Debug, {}>;

export type Hotspot =
  | OfferPromoteJobBoardsHotspot
  | OfferPipelineBadgesHotspot
  | SettingsIntegrationsPageHotspot
  | SettingsIntegrationsItemBadges
  | CandidateProfileOverviewHotspot
  | CandidateProfileMoreHotspot
  | CandidateProfileBadgesHotspot
  | CandidatesTableBadgesHotspot
  | CompanyTeamMembersAddHotspot
  | DebugHotspot;
